/*
 *  Bootstrap Nice Select English (United States) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['en-US'] = localisation.locales['en'] = {
    formatSearch() {
        return "Searching...";
    },
    formatHelpForTagging() {
        return "For creating own tags, focus the input field and then press 'Enter' or ',' or 'Spacebar' to add it to the list";
    }
}

export default localisation;